import * as PIXI from "pixi.js";
import  Simplex from "perlin-simplex";
import CurlPixi  from "./CurlPixi";
import Loader    from "./loaders/Loader";
import Library   from "./utils/Library";
import { gsap } from "gsap";

import { PixiPlugin } from "gsap/PixiPlugin";
import SpriteWithFilters from "../../../../public/images/game/assets/SpriteWithFilters";
import Background from "./components/Background";
import SpriteWithColorFilter from "./components/SpriteWithColorFilter";
import _ from "lodash";
import SpriteTree from "../../../../public/images/game/assets/SpriteTree";
import Environment from "./environment/Environment";
import Display from "./responsive/Display";
import Events from "./events/Events";
import User from "./utils/User";
export default class GameLauncher
{
    constructor (canvas)
    {
        this.canvas = canvas;
        this.prepare();
        this.build();
    }


    prepare ()
    {
        gsap.registerPlugin(PixiPlugin);
        this.fctOnComplete = this.onLoadComplete.bind(this);
        this.bReplaced = false;

        document.addEventListener("route-change", this.onRouteChange.bind(this));
        document.addEventListener(Events.ChangeEmotion, this.onChangeEmotion.bind(this));
        document.addEventListener(Events.MoveScene, this.onMoveScene.bind(this));
        document.addEventListener(Events.ReplaceScene, this.onReplaceScene.bind(this));
        document.addEventListener(Events.ReplaceCharacter, this.onReplaceCharacter.bind(this));
        document.addEventListener(Events.UpdteSceneAndCharacter, this.onUpdateSceneAndCharacter.bind(this));
        document.addEventListener(Events.ShowMaestro, this.onSlideMaestroIn.bind(this));
    }

    onChangeEmotion (event)
    {

        if (this.environment)
        {
            this.environment.changeEmotion(event.detail.emotion);
        }
    }
    onRouteChange (event)
    {
        if (this.environment)
        {
            this.environment.showScene(event.detail.scene, event.detail.done);
        }
    }

    onMoveScene (event)
    {
        if (this.environment)
        {
            this.environment.showScene(event.detail.scene, event.detail.done);
        }
    }

    onUpdateSceneAndCharacter (event)
    {
        if (this.environment)
        {
            //this.environment.updateSceneAndCharacter(event.detail.scene, event.detail.character, event.detail.done);

            if (event.detail.account.character != this.currentCharacter)
            {
                this.onLoadCharacter(event.detail.account.character, event.detail.done);

                this.environment.replaceCharacter(event.detail.character, event.detail.done);
            }
        }
    }
    onReplaceScene (event)
    {

        if (this.environment)
        {

            this.environment.replaceScene(event.detail.scene, event.detail.done, event.detail.cleared);

        }
    }

    onReplaceCharacter (event)
    {

        if (this.environment)
        {
            this.environment.replaceCharacter(event.detail.character, event.detail.done);
        }
    }

    onSlideMaestroIn ()
    {
        if (this.environment)
        {
            this.environment.slideMaestroIn();
        }
    }
    build ()
    {
        this.app = new PIXI.Application
                           (
                               {
                                   view:            this.canvas,
                                   resolution:      window.devicePixelRatio,
                                   transparent:     false,
                                   //backgroundColor: 0xecdad3, //color for loading, we should change it after load
                                   backgroundColor: 0xFFFFFF, //color for loading, we should change it after load
                                   width:           window.innerWidth,
                                   height:          window.innerHeight,
                                   antialias:       true,
                                   useContextAlpha: false,
                                   autoDensity:     true,

                               }
                           );

        globalThis.__PIXI_APP__ = this.app;

        globalThis.__PIXI_RENDERER__ = this.app.renderer;
        globalThis.__PIXI_STAGE__ = this.app.stage;

        this.container = new PIXI.Container();
        this.container.name = "main-container";

        this.app.stage.addChild(this.container);


        this.canvas.style = "visibility: hidden";

       // let curl = new CurlPixi()

        //this.container.addChild(curl);


        let {decor, character} = User.getDecorAndCharacter();

        this.currentSceneDecor = decor;
        this.currentCharacter = character;

        Loader.setAsLoaded(decor);
        Loader.setAsLoaded(character);

        this.loader = new Loader(`/api/assets/${decor}/${character}`);
        this.loader.on("load-complete", this.fctOnComplete);

    }

    onLoadComplete ()
    {
        document.dispatchEvent(new CustomEvent("loading", {detail: {loading: false}}));

        this.loader.off("load-complete", this.fctOnComplete);


        this.environment = new Environment();
        this.environment.on(Events.LoadScene, this.onLoadScene.bind(this));
        this.environment.on(Events.LoadCharacter, this.onLoadCharacter.bind(this));

        this.container.addChild(this.environment);

        this.environment.createScene();
        this.canvas.style = "visibility: visible";


        window.addEventListener("resize", this.onResize.bind(this));
        this.onResize();
    }

    onLoadScene (decor, callback)
    {

        this.currentSceneDecor = decor;
        User.setDecor(decor);

        if (!Loader.setAsLoaded(decor))
        {

            document.dispatchEvent(new CustomEvent("loading", {detail: {loading: true}}));
            //let { decor} = User.getDecorAndCharacter();

            this.loader = new Loader(`/api/assets/${decor}`);
            this.loader.on("load-complete", () => this.onReloadSceneComplete());
        }
        else
        {
            this.onReloadSceneComplete()
        }
    }

    onLoadCharacter (character, callback)
    {

        this.currentCharacter = character;

        User.setCharacter(character);

        if (!Loader.setAsLoaded(character))
        {
            document.dispatchEvent(new CustomEvent("loading", {detail: {loading: true}}));
            //let { decor} = User.getDecorAndCharacter();

            this.loader = new Loader(`/api/character/${character}`);
            this.loader.on("load-complete", () => this.onReloadCharacterComplete(character, callback));
        }
        else
        {
            this.onReloadCharacterComplete(character, callback)
        }
    }

    onReloadSceneComplete ()
    {
        document.dispatchEvent(new CustomEvent("loading", {detail: {loading: false}}));
        this.environment.createScene()
    }

    onReloadCharacterComplete (character, callback)
    {
        document.dispatchEvent(new CustomEvent("loading", {detail: {loading: false}}));
        this.environment.createCharacter(-1, character)
        this.environment.onCharacterCreated(character, callback);


    }
    onResize ()
    {

        let width = Display.instance.getWidth();
        let height = Display.instance.getHeight();

        let strOrientation = Display.instance.getWindowOrientation();

            this.app.renderer.resize(width, height);

            this.environment.layout();
            this.environment.replaceOffsetAfterResize();
    }
    onLoadComplete2 ()
    {
        this.loader.off("load-complete", this.fctOnComplete);

        let bg = Library.instance.getResourceByKey("forest-sky");
        let bgSprite = new Background(bg.texture, "#7ED6FC");
        this.container.addChild(bgSprite);

        bgSprite.alpha = 1;
        this.bgSprite = bgSprite;

        let testAssets = ["Arbre_01.png","Arbre_03.png", "Arbre_04.png", "Arbre_05.png", "Arbre_06.png", "Arbuste_01.png", "Arbuste_02.png", "Arbuste_03.png", "Arbuste_04.png", "Bouleau_01.png","Bouleau_02.png"
            ,"Fleure_01.png","Herbe_01.png","Herbe_02.png","Herbe_03.png","Herbe_04.png","Mushroom_01.png","Mushroom_02.png","Sapin_01.png","Sapin_02.png","Sapin_03.png"];

        testAssets = testAssets.sort ((a,b) => -0.5 + Math.random());

        //testAssets = ["Arbre_04.png", "Arbre_04.png", "Arbre_04.png", "Arbre_04.png", "Arbre_04.png", "Arbre_04.png", "Arbre_04.png", "Arbre_04.png"];

        let offset = window.innerWidth / testAssets.length + 2;

        let arrAssets = [];
        for (let i = 0; i < testAssets.length; i++)
        {
            let texture = Library.instance.getTextureFromAtlas("foret", testAssets[i]);

            let sprite = new SpriteWithColorFilter(texture);
            sprite.x = 0 + (i * offset);
            sprite.y = window.innerHeight - 10;
            sprite.anchor.y = 1;
            this.container.addChild(sprite);

            arrAssets.push(sprite);
        }
        let texture = Library.instance.getTextureFromAtlas("foret", "Arbre_04.png");

       /* let points = [];

        let guide = new PIXI.Graphics();
        guide.lineStyle(2, 0xFF0000);

        let off = 430 / 20;
        for (let i = 0; i < 20; i++)
        {
            let x = 0
            let y = i*off;

            let pt = new PIXI.Point(y, x);
            points.push(pt);

            guide.drawCircle(x, y, 2);
        }

        let tree = new PIXI.SimpleRope(texture, points, 0)
        tree.x = 200;
        tree.y = window.innerHeight - 10 - tree.height / 2;
        tree.autoUpdate = true;


        //tree.anchor.y = 1;

        this.container.addChild(tree);
        guide.x = tree.x;
        guide.y = tree.y;

        this.container.addChild(guide);

        this.pts = points;*/
        this.colorScheme = {
            night:{
                exposure: -0.5,
                gamma: 0.0,
                saturation: 0.5,
                contrast: 0.5,
                temperature: 0.0,
                sky: "#2B4956"
            },
            calm:
                {
                    exposure: 0.2,
                    gamma: 0.0,
                    saturation: 1.0,
                    contrast: 1.0,
                    temperature: 0.0,
                  sky:"#B7E9FF"
                },
            joy:
                {
                    exposure: 0.0,
                    gamma: 0.0,
                    saturation: 2.0,
                    contrast: 1.0,
                    temperature: 200,
                    sky:"#00B3FF"
                },
            day:{
                exposure: 0.2,
                gamma: 0.0,
                saturation: 1.0,
                contrast: 1.0,
                temperature: -200,
                sky: "#7ED6FC"
            }
        }

        this.colorQueue = ["night", "calm", "joy", "day"];

        setInterval( () => this.changeColor(arrAssets), 4000);


    }

    changeEmotion (emotion)
    {

        let scheme = this.colorScheme[emotion];
        let sky = scheme.sky;

        delete scheme.sky;

        let objScheme = JSON.parse(JSON.stringify( scheme ));

        let delay = 0;
        let duration = 0.5;
        gsap.to(this.bgSprite, 1, {color: sky, delay, duration});

        for (let i = 0; i < this.container.children.length; i++)
        {
            let asset = this.container.children[i];
            let delay = 0.1 + Math.random() * 0.2;
            let duration = 0.2 + Math.random() * 0.4;
            gsap.to(asset, 1, {...objScheme, delay, duration});
        }
    }
    changeColor (arrAssets)
    {
        // this.changeExposure(arrAssets);
        // this.changeSaturation(arrAssets);
        // this.changeContrast(arrAssets);

        let scheme = this.colorQueue.shift();
        this.colorQueue.push(scheme);

        let objScheme = JSON.parse(JSON.stringify( this.colorScheme[scheme] ));
        let sky = objScheme.sky;


        delete objScheme.sky;

        for (let i = 0; i < arrAssets.length; i++)
        {
            let asset = arrAssets[i];
            let delay = 0.1 + Math.random() * 0.2;
            let duration = 0.2 + Math.random() * 0.4;
            gsap.to(asset, 1, {...objScheme, delay, duration});
        }

        let delay = Math.random ();
        let duration = 0.5 + Math.random();
        gsap.to(this.bgSprite, 1, {color: sky, delay, duration});
        //in gsap, tween color

        //this.pts[0].y += -5 + Math.random() * 10;
    }

    changeExposure (arrAssets)
    {
        let rand = _.random(0, arrAssets.length - 1);
        let asset = arrAssets[rand];
        let exposure = -1 + Math.random() * 2;
        gsap.to(asset, 0.5, {exposure});
    }

    changeSaturation (arrAssets)
    {
        let rand = _.random(0, arrAssets.length - 1);
        let asset = arrAssets[rand];

        let saturation =  Math.random() * 2;
        gsap.to(asset, 0.5, {saturation});
    }

    changeContrast (arrAssets)
    {
        let rand = _.random(0, arrAssets.length - 1);
        let asset = arrAssets[rand];

        let saturation =  Math.random() * 2;
        gsap.to(asset, 0.5, {saturation});
    }

}
